<template>
  <div class="lab flex flex-column flex-middle">
    <div class="lab-head">热门服务机构</div>
    <div class="lab-imgs">
      <div class="lab-img pointer" v-for="(item, index) in data" :key="index">
        <img
          :src="item.checkmallBusinessLogo || $oss('common/empty-img.png')"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { carefullyChosenLabs } from "@/api/home";
export default {
  props: {
    cateId: {
      type: Number,
      default: null,
    },
    bg: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      data: [],
    };
  },
  created() {
    this.getCarefullyChosenLabs();
  },
  methods: {
    async getCarefullyChosenLabs() {
      const res = await this.$axios.post(carefullyChosenLabs, {
        limit: 6,
        serviceCategorySuperId: this.cateId,
      });
      this.data = res || [];
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.lab {
  padding: 20px;
  background: url($oss-url + "home/bg/bg-1.png") no-repeat center 0 / 100% 50px,
    url($oss-url + "home/bg/bg-2.png") no-repeat center 100% / 100% 50px;
  background-color: #fff;
  &-head {
    text-align: center;
    font-size: 14px;
    padding: 5px 10px;
    font-weight: normal;
    color: white;
    background: #ff1d36;
    border-radius: 25px;
    margin-bottom: 20px;
  }
  &-img {
    text-align: center;
    background: white;
    padding: 10px;
    border: 1px solid #ccc;
    margin-bottom: 10px;
    > img {
      width: 100%;
      height: 45px;
      object-fit: contain;
    }
  }
}
</style>
